/*
 *   File : change-basket-name.js
 *   Author : https://evoqins.com
 *   Description : Change basket name modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";

// *********** Components ***************//
import { PrimaryButton, SecondaryButton } from "../Buttons";
import { CustomTextInput } from "../Form-Elements";

// *********** Assets ***************//
import Close from "../../Assets/Images/close-btn.svg";

function ChangeBasketNameModal(props) {

    const [basketName, setBasketName] = useState(props.basketName || "");
    const [basketNameError, setBasketNameError] = useState("");
    const [activeAction, setActiveAction] = useState("");

    useEffect(() => {
        if (!props.loading) {
            setActiveAction("");
        }
    }, [props.loading]);

    const _handleNameChange = (value) => {
        setBasketName(value);
        setBasketNameError("");
    };

    const _handleChangeName = () => {
        const next_name = basketName.trim();

        if (next_name === "") {
            setBasketNameError("Please enter the name");
            return;
        }

        setActiveAction("change");
        props.onChangeName(next_name);
    };

    const _handleSkip = () => {
        setActiveAction("skip");
        props.onSkip();
    };

    return (
        <div className="modal fade"
            id="change-basket-name-modal"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="change-basket-name-label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow">
                    <div className="modal-header justify-content-space-between pt-4 px-3 px-sm-4 pb-4 border-0">
                        <h6 id="change-basket-name-label"
                            className="mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px">
                            {props.title || "Change basket name"}
                        </h6>
                        <img src={Close}
                            id="change-basket-name-modal-close"
                            draggable={false}
                            className="cursor-pointer"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt="close"
                            width={32}
                            height={32}
                            onClick={props.onClose} />
                    </div>
                    <div className="modal-body pb-4 px-3 px-sm-4 pt-0">
                        <div className="e-bg-cultured e-border-radius-16 p-3">
                            <CustomTextInput label="Name"
                                type="text"
                                value={basketName}
                                errorMsg={basketNameError}
                                floatingLabel={false}
                                wrapperClassName="no-margin-bottom"
                                className="w-100"
                                handleChange={_handleNameChange} />
                        </div>
                        {
                            props.skipButtonName ?
                                <div className="d-flex gap-3 mt-4 flex-nowrap">
                                    <SecondaryButton name={props.skipButtonName}
                                        disabled={props.loading}
                                        borderRadius="e-border-radius-10"
                                        loading={props.loading && activeAction === "skip"}
                                        className="w-50 padding-12px-top padding-12px-bottom e-border-radius-10 e-border-1px-bright-gray"
                                        onPress={_handleSkip} />
                                    <PrimaryButton name="Change"
                                        className="w-50 padding-12px-top padding-12px-bottom e-border-radius-10"
                                        loading={props.loading && activeAction === "change"}
                                        disabled={props.loading}
                                        onPress={_handleChangeName} />
                                </div>
                                :
                                <PrimaryButton name="Change"
                                    className="w-100 padding-12px-top padding-12px-bottom mt-4"
                                    loading={props.loading}
                                    disabled={props.loading}
                                    onPress={_handleChangeName} />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangeBasketNameModal;
